/**
 * Mobile Horizontal Scroll Component JS
 * 移动端横向滚动组件 - 滑动指示器交互
 */

class MobileScrollIndicators {
  constructor(container) {
    this.container = container;
    this.scrollContainer = container.querySelector('.mobile-scroll-container');
    this.indicatorsWrapper = container.querySelector('.mobile-scroll-indicators');
    
    if (!this.scrollContainer || !this.indicatorsWrapper) return;
    
    this.indicators = Array.from(this.indicatorsWrapper.querySelectorAll('.mobile-scroll-indicator'));
    this.init();
  }

  init() {
    this.updateActiveIndicator();
    this.scrollContainer.addEventListener('scroll', () => this.updateActiveIndicator());
  }

  updateActiveIndicator() {
    if (!this.indicators.length) return;

    const scrollWidth = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
    const scrollLeft = this.scrollContainer.scrollLeft;
    const progress = scrollWidth > 0 ? scrollLeft / scrollWidth : 0;
    
    const activeIndex = Math.min(
      Math.round(progress * (this.indicators.length - 1)),
      this.indicators.length - 1
    );

    this.indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === activeIndex);
    });
  }
}

// 自动初始化所有滑动指示器
document.addEventListener('DOMContentLoaded', () => {
  const scrollWrappers = document.querySelectorAll('.mobile-scroll-wrapper');
  scrollWrappers.forEach(wrapper => {
    if (window.innerWidth <= 768) {
      new MobileScrollIndicators(wrapper);
    }
  });
});

// 窗口大小改变时重新初始化
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    const scrollWrappers = document.querySelectorAll('.mobile-scroll-wrapper');
    scrollWrappers.forEach(wrapper => {
      if (window.innerWidth <= 768) {
        new MobileScrollIndicators(wrapper);
      }
    });
  }, 250);
});
